"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var ButtonV2_scss_1 = __importDefault(require("./ButtonV2.scss"));
var ButtonV2 = function (props) {
    return (react_1["default"].createElement(button_1["default"], __assign({ className: ButtonV2_scss_1["default"].ButtonV2 + " " + (props.type === 'text' && ButtonV2_scss_1["default"].ButtonV2Outline) }, props)));
};
exports["default"] = ButtonV2;
